<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UaQidS/tc-custom/9781429910415.jpg?1719985970432" alt="This image is the cover for the book Cowl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cowl
      </h1>
      <p class="bookDescription body article font2">
        <p><b>With <i>Cowl</i>, Neal Asher, acclaimed author of <i>Gridlinked</i> and <i>The Skinner</i>, has created a powerful time-travel novel for the 21st Century, a violent thrill ride that will leave you breathless </b><br/><br/>In the far future, the Heliothane Dominion is triumphant in the solar system, after a bitter war with their Umbrathane progenitors. But some of the Umbrathane have escaped into the distant past, where they can position themselves to wreak havoc across time and undo their defeat. The most fanatical of them is the superhuman Cowl, more monstrous than any of the creatures outside his prehistoric redoubt. <br/><br/>Cowl sends his terrifying hyperdimensional pet, the torbeast, hunting through all the timelines for human specimens. It sheds its scales -- each one an organic time machine -- where its master orders. Anyone who picks one up is dragged back to the dawn of time, where Cowl awaits. Then the beast can feed, growing ever larger . . . <br/><br/>In our own near-future, Tack is one of U-gov's programmable killers. When a scale latches onto him, his doom seems inevitable, but the Heliothane have other ideas: they can use Tack against Cowl. Tack is no stranger to violence, but the Heliothane, hardened in their struggle for humanity's very existence, have much to teach him. He will need it all for his encounter with Cowl.<br/><br/>Once one of Tack's targets, Polly escaped with her life when a torbeast scale snatched her. Now, like Tack, she must learn fast as she is dragged back to Day Zero. To cheat death again, she will have to help him save the human race.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neal Asher
      </h2>
      
      <p class="authorDescription body article"><P><B>Neal Asher </B>lives in Chelmsord, Essex, UK.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?537e870d